export default "/_nuxt/3cfebe8e7bebfb7ad80b560f46214bbf.svg";